{
  "namingTriad": {
    "security": "No-Witness-Revelation-in-ZKP-Compliance",
    "governance": "Privacy-Preserving Compliance Audit",
    "mathematical": "Propositional Truncation as the ZKP Compliance Predicate"
  },
  "entries": [
    {
      "id": "permit",
      "theorem": "PERMIT",
      "generator": "G1",
      "witness": "Slice morphism f : X → A in Slice(A)",
      "predicate": "∥ DAGPath authority-dag X A ∥ — a subject reaches an authority",
      "encoding": "DAG reachability (NL-complete) via Merkle-path commitment over the authority adjacency structure",
      "privacyGain": "Prove an action is authorized without revealing the authority hierarchy or which subjects hold which authorities.",
      "accent": "carrier"
    },
    {
      "id": "data-origin",
      "theorem": "DATA.ORIGIN",
      "generator": "G2",
      "witness": "Grothendieck fibration lift of datum d over origin o",
      "predicate": "∥ provenance-chain d ↠ o ∥ — a certified chain terminates at the origin",
      "encoding": "Merkle-tree commitment to the provenance chain; prove the chain connects d to o without intermediate nodes",
      "privacyGain": "Certify end-to-end provenance without revealing the sensitive intermediate processing steps.",
      "accent": "witness"
    },
    {
      "id": "separate",
      "theorem": "SEPARATE",
      "generator": "G2",
      "witness": "Absence of a forbidden square in the double category",
      "predicate": "∥ ∀ paths · none is a forbidden square A ↝ B ∥ — a non-membership proof",
      "encoding": "co-NIZK / bounded enumeration over the double-category topology (RD-03 gives the soundness-error bound)",
      "privacyGain": "Prove two domains are information-flow separated without disclosing the domain topology.",
      "accent": "predicate"
    },
    {
      "id": "precommit",
      "theorem": "PRECOMMIT",
      "generator": "G3",
      "witness": "Graded-monad token for commit c at grade t",
      "predicate": "∥ token at grade t · t_commit < t_authorize ∥ — commitment precedes authorization",
      "encoding": "Commitment-scheme analog: prove the token is at the correct grade, bound to the action, without revealing the commitment value",
      "privacyGain": "Prove a commitment was made before authorization without revealing what was committed.",
      "accent": "challenge"
    },
    {
      "id": "res-consume",
      "theorem": "RES.CONSUME",
      "generator": "G4",
      "witness": "Linear morphism consuming resource r for effect e (an ILL derivation)",
      "predicate": "∥ linear consumption of r ∥ — resource consumed exactly once",
      "encoding": "ZKP over the ILL proof object (RD-22): prove possession of a derivation without revealing the derivation tree",
      "privacyGain": "Prove a budget was consumed exactly once without revealing the budget value.",
      "accent": "response"
    },
    {
      "id": "inv-preserve",
      "theorem": "INV.PRESERVE",
      "generator": "G3",
      "witness": "F-coalgebra witness that the system preserves the invariant",
      "predicate": "∥ ∀ transitions · invariant preserved ∥ — a universal-quantifier certificate",
      "encoding": "Bounded-depth unrolling or a STARK over the recursive computation; bisimulation certificate from RD-23",
      "privacyGain": "Prove an invariant holds across all transitions without revealing the transition system.",
      "accent": "accent"
    }
  ]
}
